export const truncateString = (val: string, maxLength: number) => (!val || val.length <= maxLength) ? val : val!.slice(0, maxLength + 1) + " . . .";